import React from 'react';
import NuDate from '../../../../Components/Utils/NuDate';

function ViewEmailSent({ item, data, open, onCancel }) {
  const displayItem = item || data;

  return (
    <div className="w-full flex flex-col space-y-4 p-4 bg-white rounded-lg shadow-sm">
  {/* Subject and Status */}
  <div className="w-full flex flex-wrap items-center justify-between gap-2">
    <h3 className="text-sm font-semibold text-gray-800 truncate flex-1 min-w-[50%]">
      {displayItem?.subject || "-"}
    </h3>

    {/* <div className="sm:mt-0 mt-1 h-6 border rounded-full mr-3 border-baseColor-primary text-xs inline-flex w-auto flex-shrink-0 justify-center overflow-hidden">
  <p className="w-12 bg-white text-black px-2 flex items-center justify-center">
    Status
  </p>
  <p className="bg-baseColor-primary w-10 text-white px-2 flex items-center justify-center">
     {displayItem?.status || "None"}
  </p>
</div> */}
    <div className=" flex items-center  overflow-hidden rounded-full text-[10px] 2xl:text-xs  ">
                            <div className="  p-2 h-6  bg-white  rounded-s-full text-xs flex items-center border border-textColor-main">
                              Status{" "}
                            </div>
                            <div className="  p-2 h-6  bg-textColor-main text-white text-xs  rounded-e-full flex items-center">
                              {displayItem?.status || "-"}
                            </div>
                          </div>
    {/* <div className="border rounded-md border-textColor-main text-xs flex">
      <p className="bg-white text-textColor-main p-1 px-2 rounded-l-md">Status</p>
      <p className="bg-textColor-main text-white p-1 px-2 rounded-r-md">
        {displayItem?.status || "None"}
      </p>
    </div> */}
  </div>

  {/* Details Grid */}
  <div className="grid grid-cols-5 gap-y-2 text-sm">
    {/* Date */}
    <div className="col-span-1 text-xs text-gray-500 font-medium">Date</div>
    <div className="col-span-4 text-xs text-gray-700">
      {displayItem?.date ? (
        <NuDate value={displayItem?.date} format="DD-MMM-YYYY, hh:mm A" />
      ) : (
        "N/A"
      )}
    </div>

    {/* To */}
    <div className="col-span-1 text-xs text-gray-500 font-medium">To</div>
    <div className="col-span-4 text-xs text-gray-700">
      <div className="flex flex-wrap gap-1">
        {displayItem?.toMails?.length > 0
          ? displayItem.toMails.map((mail, index) => (
              <span
                key={index}
                className="bg-blue-50 text-blue-700 border border-blue-200 rounded-full px-2 py-0.5 text-[11px]"
              >
                {mail}
              </span>
            ))
          : "-"}
      </div>
    </div>

    {/* CC */}
    <div className="col-span-1 text-xs text-gray-500 font-medium">CC</div>
    <div className="col-span-4 text-xs text-gray-700">
      <div className="flex flex-wrap gap-1">
        {displayItem?.ccMmils?.length > 0
          ? displayItem.ccMmils.map((mail, index) => (
              <span
                key={index}
                className="bg-green-50 text-green-700 border border-green-200 rounded-full px-2 py-0.5 text-[11px]"
              >
                {mail}
              </span>
            ))
          : "-"}
      </div>
    </div>
  </div>

  
<div className="mt-4 pt-3 border-t border-gray-100">
  <div className="text-gray-500 text-xs font-medium mb-2">Message</div>
  <div
    className="text-gray-700 text-xs whitespace-pre-wrap break-words max-h-[300px] overflow-y-auto p-2 border border-gray-100 rounded"
    dangerouslySetInnerHTML={{
      __html: displayItem?.message || "<p>No message content available</p>",
    }}
  ></div>
</div>
{/* <div className="mt-4 pt-3 border-t border-gray-100">
  <div className="text-gray-500 text-xs font-medium mb-2">Message</div>
  <div className="text-gray-700 text-xs break-words max-h-[300px] overflow-y-auto p-3 pt-2 border border-gray-100 rounded leading-relaxed space-y-2"
     dangerouslySetInnerHTML={{
       __html: displayItem?.message?.trim() || "<p>No message content available</p>",
     }}
></div>

</div> */}

</div>

  );
}

export default ViewEmailSent;